import styled from 'styled-components';

export const Label = styled.label`
  color: #283618;
  font-size: 14px;
  font-weight: ${(props) => (props.bold ? '900' : '500')};
  min-height: 42px;
  display: flex;
  align-items: flex-start;
  line-height: 1;
`;
